import { useCallback } from 'react';
import { useFunctionResult } from 'record-it-components/hooks/useFunctionResult/useFunctionResult';
import { useDayTick } from 'record-it-components/hooks/useDayTick';
import { EntityName } from 'record-it-time-common/EntityName';
import { ArrayUtils } from 'record-it-utils/utils/ArrayUtils/ArrayUtils';
import { DateUtils } from 'record-it-utils/utils/DateUtils/DateUtils';
import { WorkTimeEntry } from '../../../../classes/entities/WorkTimeEntry/workTimeEntryTypes';
import { useEntityChangedListener } from '../../useEntityChangedListener/useEntityChangedListener';
import { useEntityRepository } from '../../useEntityRepository';
import { useCurrentUser } from '../../../useCurrentUser';

export function useTodaysWorkTimeEntries(): Array<WorkTimeEntry> {
  const repository = useEntityRepository(EntityName.WorkTimeEntry);

  const { currentUser } = useCurrentUser();

  const wrappedFunction = useCallback(() => {
    if (!currentUser) {
      return [];
    }

    const entries = repository.getInDateRangeForUser({
      start: DateUtils.withCurrentTimezone().getStartOfDay(new Date()),
      end: DateUtils.withCurrentTimezone().getEndOfDay(new Date()),
      userId: currentUser.id
    });

    return entries.sort((a, b) => a.startDate.localeCompare(b.startDate));
  }, [repository, currentUser]);

  const { result, update } = useFunctionResult({
    func: wrappedFunction,
    funcArgs: [],
    resultsAreEqual: (a, b) => {
      return ArrayUtils.areShallowEqual(a, b);
    }
  });

  useEntityChangedListener(EntityName.TimeTrackingActivity, update);

  useDayTick(update);

  return result;
}
